<template>
  <div class="box">
    <button id="bttt">点击</button>
    <div class="bublle" :class="{ b1: touchUp }">{{ countIndex }}</div>
    <!-- <div class="bublle b2">2</div> -->
    <!--<div class="bublle b3"></div>
    <div class="bublle b4"></div>
    <div class="bublle b5"></div>
    <div class="bublle b6"></div> -->
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { openToast } from "toast-ts";

@Options({
  props: {
    toastShow: Boolean,
    count: Number
  },
  watch: {
    count(newVal, oldVal) {
      if (newVal != oldVal) {
        this.countIndex = newVal;
      }
    }
  }
})
export default class ValueAnimation extends Vue {
  touchUp = false;
  countIndex = 0;
  mounted() {
    const btn = document.getElementById("bttt") as HTMLButtonElement;
    btn.addEventListener("touchstart", () => {
      console.log("OnUp");
      this.touchUp = true;
    });
    btn.addEventListener("touchend", () => {
      // this.isShowControls = true;
      console.log("OnDown");
      this.touchUp = false;
    });
    btn.addEventListener("touchcancel", () => {
      // this.isShowControls = true;
      console.log("touchcancel");
      openToast("touchcancel");
    });
    btn.addEventListener("touchmove", () => {
      // this.isShowControls = true;
      console.log("touchmove");
      openToast("touchmove");
    });
  }

  onClick() {
    console.log();
  }
}
</script>

<style>
/* * {
  margin: 0;
  padding: 0;
}*/

/* html,
body {
  background-color: skyblue;
  height: 100%;
  overflow: hidden;
} */
.box {
  width: 100%;
  height: 100%;
}
.bublle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  box-shadow: 0 20px 30px rgb(255, 255, 255, 0.2),
    inset 0px 10px 30px 5px rgb(255, 255, 255, 0.4);
}
.b1 {
  left: 50%;
  top: 0%;
  background-image: linear-gradient(#9e8ef3, #7d4feb, #ae69f3);
  font-size: 10px;
  text-align: center;
  color: white;
  transform: scale(0.1);
  animation: pao 2s linear infinite, direction 6s ease-in-out infinite alternate;
}
.b2 {
  left: 50%;
  top: 0%;
  background-image: linear-gradient(#c9f587, #80d83c, #87df7e);
  font-size: 10px;
  text-align: center;
  color: white;
  transform: scale(0.1);
  animation: pao1 2s linear infinite, direction 4s ease-in-out infinite;
}
.b3 {
  left: 69%;
  top: 0%;
  transform: scale(0.7);
  animation: pao 2s linear infinite, direction 2s ease-in-out infinite alternate;
}
.b4 {
  left: 37%;
  top: 0%;
  transform: scale(0.3);
  animation: pao 4s linear infinite, direction 3s ease-in-out infinite alternate;
}
.b5 {
  left: 46%;
  top: 0%;
  transform: scale(0.5);
  animation: pao 3s linear infinite, direction s ease-in-out infinite alternate;
}
.b6 {
  left: 50%;
  top: 0%;
  transform: scale(0.8);
  animation: pao 5s linear infinite, direction 3s ease-in-out infinite alternate;
}
@keyframes pao {
  0% {
    transform: scale(0.2);
    margin-top: 70%;
    opacity: 1;
  }
  25% {
    margin-left: -5px;
  }
  35% {
    transform: scale(1);
  }
  50% {
    margin-left: -15px;
  }
  75% {
    margin-left: -10px;
    opacity: 1;
  }
  100% {
    margin-left: -20px;
    opacity: 0.1;
    margin-top: 0px;
    transform: scale(1);
  }
}
@keyframes pao1 {
  0% {
    transform: scale(0.2);
    margin-top: 70%;
    opacity: 1;
  }
  25% {
    margin-left: 15px;
  }
  35% {
    transform: scale(1);
  }
  50% {
    margin-left: 25px;
  }
  75% {
    margin-left: 35px;
    opacity: 1;
  }
  100% {
    margin-left: 15px;
    opacity: 0.1;
    margin-top: 0px;
    transform: scale(1);
  }
}
@keyframes driection {
  0% {
    margin-left: 10px;
  }
  100% {
    margin-left: 50px;
  }
}
@keyframes twinkle {
  from {
    background-color: yellow;
    -webkit-box-shadow: 0 0 9px #333;
  }
  50% {
    background-color: yellow;
    -webkit-box-shadow: 0 0 18px #91bd09;
  }
  to {
    background-color: yellow;
    -webkit-box-shadow: 0 0 9px #333;
  }
}
@keyframes size {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
